import { Button, Modal, Typography } from 'antd';
import React, { type FC, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store/reducers';
import type { Message } from '../BasicComponents/StateMessage';
import { Tristate } from '../ButtonWithSpinner';
import { LoginForm } from '../LoginForm';

const { Title } = Typography;

export const LoginButton: FC = () => {
  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const navigate = useNavigate();
  const [isLoggingIn, setIsLoggingIn] = useState<Tristate>(Tristate.NORMAL);
  const [message, setMessage] = React.useState<Message | null>(null);
  const { login } = useStore((s) => s.users.actions);

  const handleLogin = useCallback(async (email: string, password: string) => {
    setMessage(null);

    try {
      setMessage(null);
      setIsLoggingIn(Tristate.SPINNING);
      await login(email, password);
      setIsLoggingIn(Tristate.NORMAL);
      Modal.destroyAll();
    } catch (error) {
      setIsLoggingIn(Tristate.FAILURE);
      setMessage({ error: 'Wrong email or password. Or no network connection.' });
      console.error(error);
    }
  }, []);

  const handleForgetPasswordClick = useCallback(() => {
    Modal.destroyAll();
    navigate('/auth/forgot-password', { state: { fromLogin: true } });
  }, []);
  const handleRegisterClick = useCallback(() => {
    Modal.destroyAll();
    navigate('/auth/register');
  }, []);

  return (
    <>
      <Button ghost type="primary" onClick={() => setLoginModalVisible(true)}>
        Login
      </Button>
      <Modal
        open={loginModalVisible}
        onCancel={() => setLoginModalVisible(false)}
        title={<Title level={2}>Login</Title>}
        footer={null}
        maskClosable
      >
        <LoginForm
          onLogin={handleLogin}
          isLoggingIn={isLoggingIn}
          message={message}
          onForgetPasswordClick={handleForgetPasswordClick}
          onRegisterClick={handleRegisterClick}
        />
      </Modal>
    </>
  );
};
